import { render, staticRenderFns } from "./JobSearchPills.vue?vue&type=template&id=1b1808cb&scoped=true&"
import script from "./JobSearchPills.vue?vue&type=script&lang=ts&"
export * from "./JobSearchPills.vue?vue&type=script&lang=ts&"
import style0 from "./JobSearchPills.vue?vue&type=style&index=0&id=1b1808cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1808cb",
  null
  
)

export default component.exports